import { Shield, FileCheck, Eye, Scale, CheckCircle, AlertTriangle } from 'lucide-react';

const ProtestProof = () => {
  const protestStats = [
    { label: 'GAO Sustained Protest Rate', value: '15-20%', subtext: 'of protests filed' },
    { label: 'Average Protest Delay', value: '60-100', subtext: 'days to resolution' },
    { label: 'Cost Per Protest', value: '$50K-$200K+', subtext: 'to the agency' }
  ];

  const defenseFeatures = [
    {
      icon: FileCheck,
      title: 'Every Recommendation Linked to Evidence',
      desc: 'AI suggestions trace directly back to source documents. No "black box" decisions.'
    },
    {
      icon: Eye,
      title: 'Complete Audit Trail from Day One',
      desc: 'Who did what, when, and why. Automatically documented throughout the process.'
    },
    {
      icon: Scale,
      title: 'Defensible Scoring Generated Automatically',
      desc: 'Evaluation narratives that hold up to scrutiny, with clear rationale for every score.'
    },
    {
      icon: Shield,
      title: 'FAR/DFARS Compliance Pre-Checked',
      desc: 'Catch issues before they become protest fodder. AI flags problems while there\'s still time to fix them.'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-indigo-900">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 border border-amber-500/30 text-amber-400 font-medium rounded-full mb-6">
            <AlertTriangle className="w-5 h-5" />
            <span>The #1 Fear in Acquisition</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-6">
            Built to Survive{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500">GAO Scrutiny</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-3xl mx-auto">
            Protests derail programs, drain resources, and end careers. 
            AcuSightPro builds your defense from the first click.
          </p>
        </div>

        {/* Protest Stats */}
        <div className="grid md:grid-cols-3 gap-6 mb-16">
          {protestStats.map((stat, index) => (
            <div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 text-center">
              <div className="text-sm text-slate-400 mb-2">{stat.label}</div>
              <div className="text-4xl font-bold text-red-400 mb-1">{stat.value}</div>
              <div className="text-sm text-slate-500">{stat.subtext}</div>
            </div>
          ))}
        </div>

        {/* Defense Features */}
        <div className="bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-white/10">
          <h3 className="text-2xl font-bold text-white mb-8 text-center">
            Your Protest Defense, Built-In
          </h3>
          <div className="grid md:grid-cols-2 gap-6">
            {defenseFeatures.map((feature, index) => (
              <div key={index} className="flex gap-4">
                <div className="w-12 h-12 bg-gradient-to-br from-emerald-500 to-teal-600 rounded-xl flex items-center justify-center flex-shrink-0">
                  <feature.icon className="w-6 h-6 text-white" />
                </div>
                <div>
                  <h4 className="font-bold text-white mb-1">{feature.title}</h4>
                  <p className="text-slate-400 text-sm">{feature.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-emerald-500/20 border border-emerald-500/30 rounded-full px-6 py-3">
            <CheckCircle className="w-6 h-6 text-emerald-400" />
            <span className="text-emerald-300 font-semibold">
              "When the IG comes knocking, you&apos;ll be ready."
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProtestProof;
